export const setColumns = (columnInfo) => {
  const { ids, names } = columnInfo
  const cols = names.map((i, e) => {
    return { title: i, field: e + "", attrId: ids[e], sortable: true };
  });

  // const nameClick = (h, { row, column }) => {
  //   // 渲染链接
  //   // console.log(row,column);
  //   return (
  //     <a class="link" onClick={() => this.rowClick(row, column)}>
  //       {row[column.property]}
  //     </a>
  //   );
  //   // return [
  //   //   <span class="link_" onClick={() => this.rowClick(row, column)}>
  //   //     {" "}
  //   //     {row[column.property]}{" "}
  //   //   </span>,
  //   // ];
  // };
  // cols[0].slots = {
  //   default: nameClick,
  // };
  return cols;
};
